import { render } from "./SejaParceiro.vue?vue&type=template&id=6d014d66&scoped=true"
import script from "./SejaParceiro.vue?vue&type=script&lang=js"
export * from "./SejaParceiro.vue?vue&type=script&lang=js"

import "./SejaParceiro.vue?vue&type=style&index=0&id=6d014d66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d014d66"]])

export default __exports__